module.exports = __webpack_public_path__ + "static/media/male.cc39dc30.png";